import { OrderStatusType } from '@/entities/gridTables/model/OrderStatusType'
import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { refreshData } from './refreshData'

export type MoveRunsheetAction = {
  action: string
  dateOfOperation: string | null
  orderId: EntityId
  orderStatusType: OrderStatusType
}

type CloseRunsheetPayload = {
  runsheetId: EntityId
  runsheetDate: string
  actions: MoveRunsheetAction[]
}

export const closeRunsheet = createAsyncThunk<EntityId[] | null, CloseRunsheetPayload, ThunkApiContext>(
  'schedules/closeRunsheet',
  async ({ runsheetId, runsheetDate, actions }, { dispatch }) => {
    const updatedRunsheets = await OLMSApiService.post<EntityId[]>('/runsheet/closeRunsheet', {
      runsheetId,
      actions,
    })

    if (!updatedRunsheets) return null

    await dispatch(refreshData({
      additionalHistoricalRunsheetDates: [runsheetDate],
    }))

    dispatch(setToast({
      open: false,
      severity: 'success',
      title: 'Close Runsheet Success',
      content: 'Runsheet has been successfully closed',
    }))

    return updatedRunsheets
  },
)